import request from '@/utils/request'

// 先服务器确认订单信息
// groupNo：拼单参团时传团号（结算台按团价展示）；开团时不传
export const confirmOrderInfoApi = ({ mode, remark, goodsId, goodsNum, goodsSkuId, cartIds, groupNo }) => {
  return request.get('/checkout/order', {
    params: {
      mode,
      delivery: 10,
      payType: 10,
      couponId: 0,
      isUsePoints: 0,
      remark,
      goodsId,
      goodsNum,
      goodsSkuId,
      cartIds,
      groupNo
    }
  })
}

// 提交订单（拼单模式：创建拼单团或参团）
export const submitOrderApi = ({ mode, remark, goodsId, goodsNum, goodsSkuId, cartIds, groupNo }) => {
  return request.post('/checkout/submit', {
    mode,
    delivery: 10,
    payType: 10,
    couponId: 0,
    isUsePoints: 0,
    remark,
    goodsId,
    goodsNum,
    goodsSkuId,
    cartIds,
    groupNo
  })
}
// 发起支付（微信 JSAPI/H5/Native / 支付宝支付）
// paymentMethod: 'wechat' | 'alipay'
// options: { openid: 微信JSAPI支付的用户openid, tradeType: 'jsapi' | 'h5' | 'native' | '' }
export const payOrderApi = (orderId, paymentMethod, options = {}) => {
  return request.post('/payment/submit', {
    order_id: orderId,
    payment_method: paymentMethod,
    openid: options.openid || '',
    trade_type: options.tradeType || ''
  })
}

// 查询支付结果（支付页每 3 秒轮询一次，不弹加载中）
// queryWechat=true 时：订单仍待支付则主动向微信「订单查询」接口确认（JSAPI 支付成功回调后兜底，防 notify 丢失）
export const getPaymentResultApi = (orderId, queryWechat = false) => {
  return request.get('/payment/result', {
    params: {
      order_id: orderId,
      ...(queryWechat ? { query_wechat: '1' } : {})
    },
    silent: true
  })
}

// 获取系统支付设置（判断哪些支付方式已开启）
export const getPaySettingsApi = () => {
  return request.get('/settings/get', { silent: true })
}


